import liff from '@line/liff'

/**
 * Opens a LINE Official Account profile/chat.
 * On mobile devices or within the LINE client, it uses the custom 'line://' scheme for a direct redirect.
 * On desktop browsers, it falls back to the HTTPS universal link.
 *
 * @param basicId The basic ID of the LINE OA (e.g., '@username')
 */
export const openLineOA = (basicId: string) => {
  const isInClient = liff.isInClient()
  const os = liff.getOS()

  if (isInClient || os !== 'web') {
    window.location.href = `line://ti/p/${basicId}`
  } else {
    liff.openWindow({
      url: `https://line.me/R/ti/p/${basicId}`,
      external: true,
    })
  }
}
